import config from '@/config'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface NodeConfig {
  algodHost: string
  algodPort: string
  algodToken: string
  indexerHost: string
  indexerPort: string
  indexerToken: string
}

interface NodeState extends NodeConfig {
  set: (value: NodeConfig) => void
}

export const useNodeStore = create<NodeState>()(
  persist(
    (set) => ({
      algodHost: config.algodHost,
      algodPort: config.algodPort,
      algodToken: config.algodToken,
      indexerHost: config.indexerHost,
      indexerPort: config.indexerPort,
      indexerToken: config.indexerToken,
      set: (value: NodeConfig) => set(value),
    }),
    {
      name: 'node-storage', // key in localStorage
    }
  )
)
